import { mapKeys } from 'lodash-es'

export const PASSED = 'PASSED'
export const FAILED = 'FAILED'
export const IN_PROGRESS = null

export const SCRAPING_TEST_CASE_RESULT_OUTCOMES = mapKeys(
  [
    { name: 'Passed', value: PASSED },
    { name: 'Failed', value: FAILED },
    { name: 'In Progress', value: IN_PROGRESS },
  ],
  'value',
)
